export default __webpack_public_path__ + "915a0b79c22a1c1f64da9e0a90a12f02.ttf";